import { Component, OnInit, Output, EventEmitter, ViewChild, OnDestroy, AfterViewInit, Inject, Optional, Renderer2, DOCUMENT, HostListener, ElementRef } from '@angular/core';
import { UNIVERSAL_INTAKE_URL } from 'src/app/core/services/appConfig/app-config.service';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authService/authentication.service';
import { enableRipple } from '@syncfusion/ej2-base';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { EmulateUserService } from 'src/app/core/services/userService/emulateuser.service';
import { LeftNavigationService } from '../../services/left-navigation.service';
import { ToastCloseArgs, ToastComponent, ToastPositionModel } from '@syncfusion/ej2-angular-notifications';
import { ToastService } from 'src/app/core/services/taoastService/toast-service.service';
import { GlobalConstants } from '../../services/constants/globalconstants';
import { DomSanitizer } from '@angular/platform-browser';
import { CompanyService, LocalconstService } from 'src/app/core/services';
import { ToolbarComponent } from '@syncfusion/ej2-angular-navigations';
import { HeaderServiceService } from '../../services/headerService/header-service.service';
import { UserRoles } from 'src/app/data/models';
import { Store } from '@ngrx/store';
import { userSelectors } from 'src/app/store/state/user';
import { Subject } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { currentUserFeatureIds } from 'src/app/store/state/user/user.selectors';
import { FEATURE_UNIVERSAL_ADMIN_ID } from 'src/app/data/models/feature/feature.constants';


enableRipple(true);
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  $onDestroy = new Subject<void>();
  public subs;
  public DialogObj;
  public logoTemplate: any = '#brandLogo';
  public userActTemplate: any = '#userDBtn';
  public emulateTemplate: any = '#emulateBtn';
  public companyLogoTemplate: any = '#companyLogo';
  public feedbackTemplate: any = '#feedback';
  public helpTemplate: any = '#help';
  public contactTemplate: any = '#contact';
  public tutorialVideoTemplate: any = '#tutorialVideo';
  public resourcePageTemplate: any = '#resourcePage';
  public goToLMSTemplate: any = '#goToLMS';
  public goToUniversalIntakeTemplate: any = '#goToUniversalIntake';
  public moreHiddenTemplate: any = '#moreHidden';
  public productSwitcherTemplate: any = '#productSwitcher';

  public toolbarComponent: any = 'toolbar';
  @Output('openCloseSideBar') openCloseSideBar = new EventEmitter();
  public currentUser: any;
  public respondUser: any;
  public currentUserCompanyLogo: any;
  @ViewChild('toasttype')
  private toastObj: ToastComponent;
  public toastPosition: ToastPositionModel = { X: 'Right' };
  isLoginTypeCMS = false;
  @ViewChild('toolbar')
  public tbObj: ToolbarComponent;
  toolBarItems = GlobalConstants.HeadertoolBarItems;
  lmsTemplateName = GlobalConstants.gotoLMSTemplateName;
  public showLMS = false;
  public universalIntakeUrl?: string;
  public hasUniversalAdmin = false;
  public isUserMenuOpen = false;
  @ViewChild('userMenuContainer') userMenuContainer: ElementRef;

  constructor(private router: Router,
    public authService: AuthenticationService,
    public emulateUserService: EmulateUserService,
    private leftNavService: LeftNavigationService,
    private companyService: CompanyService,
    private headerService: HeaderServiceService,
    private toastService: ToastService,
    private domSanitizer: DomSanitizer,
    public localConst: LocalconstService,
    private store: Store,
    @Optional() @Inject(UNIVERSAL_INTAKE_URL) universalIntakeUrl: string,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) {
    this.store.select(userSelectors.currentUser).pipe(takeUntil(this.$onDestroy), tap(user => this.currentUser = user), tap(() => this.setToolbar())).subscribe();
    this.store.select(userSelectors.respondUser).pipe(takeUntil(this.$onDestroy), tap(respondUser => this.respondUser = respondUser), tap(() => this.setToolbar())).subscribe();

    // Subscribe to Universal Admin feature flag once we know user id; fallback when currentUser available
    // Monitor logged-in user's feature ids directly from user slice
    this.store.select(currentUserFeatureIds).pipe(takeUntil(this.$onDestroy)).subscribe(ids => {
      const before = this.hasUniversalAdmin;
      this.hasUniversalAdmin = ids.includes(FEATURE_UNIVERSAL_ADMIN_ID);
      if (before !== this.hasUniversalAdmin) {
        this.setToolbar();
      }
    });

    this.universalIntakeUrl = universalIntakeUrl;

    this.subs = this.headerService.onHide$.pipe(takeUntil(this.$onDestroy)).subscribe(() => {
      this.setToolbar();
    });
    this.authService.currentUserCompanyLogo.pipe(takeUntil(this.$onDestroy)).subscribe(userLogo => this.currentUserCompanyLogo = userLogo);
    this.setToolbar();
  }
  ngOnDestroy(): void {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }

  gotohome() {
    //this.router.navigate(['/dashboard/home']);
  }

  ngOnInit() {
    this.isLoginTypeCMS = !GlobalConstants.RespondRoutes.includes(this.router.url);
    if (this.isLoginTypeCMS) {
      this.emulateUserService.menuItemsSubject.next(this.emulateUserService.getMenuItems(this.currentUser.FirstName, this.currentUser.UserEmail));
    }
    else {
      this.emulateUserService.menuItemsSubject.next(this.emulateUserService.getMenuItems(this.respondUser.CaseNumber, ''));
    }

    if (this.currentUser != null && (this.currentUser.Company.LMSCustomerflag || this.currentUser.UserRoleID == UserRoles.SA)) {
      this.showLMS = true;
    }

    if (!this.currentUserCompanyLogo) {
      if (this.isLoginTypeCMS) {
        if (this.currentUser && this.currentUser.CompanyID) {
          this.companyService.getCompanyById(this.currentUser.CompanyID).pipe(takeUntil(this.$onDestroy)).subscribe(company => {
            if (company && company.LogoImage) {
              this.authService.SetCurrentUserCompanyLogo(this.convertImageByteToImage(company.LogoImage));
            }
          });
        }
      }
      else {
        if (this.respondUser && this.respondUser.CompanyId) {
          this.companyService.getCompanyById(this.respondUser.CompanyId).pipe(takeUntil(this.$onDestroy)).subscribe(company => {
            if (company && company.LogoImage) {
              this.authService.SetCurrentUserCompanyLogo(this.convertImageByteToImage(company.LogoImage));
            }
          });
        }
      }
    }

    this.setToolbar();
  }

  public ngAfterViewInit(): void {
    this.showProductSwitcher();
  }

  private cancelClick(): void {
    this.DialogObj.hide();
  }

  openCloseSideBarForMobile() {
    this.openCloseSideBar.emit();
  }

  logoutLink() {
    this.DialogObj.hide();
    this.authService.logout();
    if (this.isLoginTypeCMS) {
      this.emulateUserService.currentEmulatedSubject.next(false);
      this.router.navigate(['/']);
    } else {
      this.router.navigate(['/respond']);
    }
  }

  onRightMenuItemClick(args: any): void {
    this.onMenuItemClick(args.element.id);
  }

  onMenuItemClick(menuId: string): void {
    this.closeUserMenu();
    switch (menuId) {
      case GlobalConstants.RightMenuProfileId:
        this.router.navigate(['/usermanagement/updateuser']);
        break;
      case GlobalConstants.RightMenuChangePasswordId:
        if (this.currentUser.ExternalAuthToken && this.currentUser.ExternalAuthToken.AuthProvider == "hq") {
          window.open(this.currentUser.ExternalAuthToken.AuthDomain + "/accounts/profile", "_blank");
        }
        else {
          this.router.navigate(['/usermanagement/changePassword']);
        }
        break;
      case GlobalConstants.RightMenuUserAccessLogId:
        this.router.navigate(['/userlist/userAccessLog']);
        break;
      case GlobalConstants.RightMenuLogoutId:
        this.DialogObj = DialogUtility.confirm({
          title: 'Logout',
          content: 'Click \'Logout\' to end your current session, or \'Cancel\' to stay logged in.',
          okButton: { text: 'Logout', click: this.logoutLink.bind(this) },
          cancelButton: { text: 'Cancel', click: this.cancelClick.bind(this), cssClass: 'e-outline' },
          closeOnEscape: false,
          animationSettings: { effect: 'Zoom' },
          zIndex: 1005,
          position: { X: 'center', Y: 'center' },
          isModal: true
        });
        break;
    }
  }

  toggleUserMenu(): void {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  closeUserMenu(): void {
    this.isUserMenuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.userMenuContainer && !this.userMenuContainer.nativeElement.contains(event.target)) {
      this.closeUserMenu();
    }
  }

  getUserDisplayName(): string {
    if (this.isLoginTypeCMS && this.currentUser) {
      return this.currentUser.FirstName || '';
    }
    if (this.respondUser) {
      return this.respondUser.CaseNumber || '';
    }
    return '';
  }

  getUserEmail(): string {
    if (this.isLoginTypeCMS && this.currentUser) {
      return this.currentUser.UserEmail || '';
    }
    return '';
  }

  getVisibleMenuItems(): { id: string; text: string; iconCss: string }[] {
    const items: { id: string; text: string; iconCss: string }[] = [];
    
    if (!this.isLoginTypeCMS) {
      // Respond user only sees logout
      items.push({ id: GlobalConstants.RightMenuLogoutId, text: 'Logout', iconCss: 'e-menu-icon e-icons e-logout' });
      return items;
    }

    // Check if Mineral org user (hide profile and change password)
    const isMineralOrg = this.currentUser?.Company?.Subsidiary?.toLowerCase() === 'mn';
    
    if (!isMineralOrg) {
      items.push({ id: GlobalConstants.RightMenuProfileId, text: 'Profile', iconCss: 'e-menu-icon e-icons e-person' });
    }

    // Check if change password should be shown
    const currentEmulatedStatus = JSON.parse(localStorage.getItem('emulatedUserStatus')) === 'true';
    if (!isMineralOrg && !currentEmulatedStatus) {
      items.push({ id: GlobalConstants.RightMenuChangePasswordId, text: 'Change Password', iconCss: 'e-menu-icon e-icons e-key' });
    }

    // User Access Log (not shown for Investigators)
    if (this.currentUser && this.currentUser.UserRoleID !== UserRoles.Investigator) {
      items.push({ id: GlobalConstants.RightMenuUserAccessLogId, text: 'User Access Log', iconCss: 'e-menu-icon e-icons e-learner-dash' });
    }

    items.push({ id: GlobalConstants.RightMenuLogoutId, text: 'Logout', iconCss: 'e-menu-icon e-icons e-logout' });
    
    return items;
  }

  stopEmulation() {
    this.emulateUserService.StopEmulateUser().pipe(
      takeUntil(this.$onDestroy),
      tap(() => {
        this.toastObj.show({
          content: 'User emulation stopped.',
          cssClass: 'e-toast-success',
          icon: 'e-success toast-icons',
        });
        localStorage.setItem('emulatedUserStatus', JSON.stringify('false'));
        const menuObj = this.leftNavService.getScopeLeftNavigation();
        for (let i = 0; i < menuObj.element.children.length; i++) {
          menuObj.element.children[i].classList.remove('e-active');
        }
        menuObj.element.children[1].classList.add('e-active');
        localStorage.setItem('currentSelectedNode', 'Users');
        setTimeout(() => {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigate(['/userlist']));
        }, 1000);
      }),
      catchError(error => {
        this.toastObj.show({
          content: 'Something went wrong.',
          cssClass: 'e-toast-danger',
          icon: 'e-error toast-icons'
        });
        return error;
      })
    ).subscribe();
  }

  onBeforeOpen(e) {
    if (this.toastObj.element.children.length > 0) {
      if (e.options.content == this.toastService.getToastContent()) {
        e.cancel = true;
      }
    } else {
      this.toastService.setToastContent(e.options.content);
    }
  }

  close(e: ToastCloseArgs) {
    this.toastService.setToastStatus(false);
  }

  convertImageByteToImage(imageBytes: any) {
    if (imageBytes) {
      let image: any;
      image = this.domSanitizer.bypassSecurityTrustUrl('data:image/jpg;base64,' + imageBytes);
      image = image.changingThisBreaksApplicationSecurity;
      return image;
    }
    return '';
  }

  setToolbar() {
    if (this.isLoginTypeCMS) {
      if (this.currentUser && this.currentUser.loginType != GlobalConstants.LoginType_Respond) {
        this.companyService.getCompanySettingsById(this.currentUser.Company.CompanyID).pipe(takeUntil(this.$onDestroy)).subscribe(x => {
          this.showLMS = x.LMSCustomerflag;
          if (this.tbObj) {
            const index = this.tbObj.items.findIndex(item => item.template === this.goToLMSTemplate);
            if (index !== -1) {
              this.tbObj.hideItem(index, !this.showLMS);
            }

            if (!this.currentUser.ExternalAuthToken || this.currentUser.ExternalAuthToken.AuthProvider != "hq") {
              let prodSwitcherIndex = this.tbObj.items.findIndex(item => item.template === this.productSwitcherTemplate);
              if (prodSwitcherIndex !== -1) {
                this.tbObj.hideItem(prodSwitcherIndex, true);
              }
            }
          }
        });
      }
    }
  }

  showProductSwitcher() {
    if (this.currentUser.ExternalAuthToken && this.currentUser.ExternalAuthToken.AuthProvider == "hq") {
      const hqUserId = this.currentUser.HQUserID;
      const domain = this.currentUser.ExternalAuthToken.AuthDomain;

      // Construct the script URL dynamically
      const scriptUrl = `${domain}/product-switcher/${hqUserId}/script.js`;

      // Create a new script element
      const s = this.renderer.createElement('script');
      s.type = 'text/javascript';
      s.src = scriptUrl;
      s.async = true;

      // Add the event listener for the 'load' event
      this.renderer.listen(s, 'load', () => {
        console.log('Product switcher script loaded successfully');
        // The script has loaded, now you can safely call the render function
        if (typeof (window as any).HQProductSwitcher !== 'undefined') {
          (window as any).HQProductSwitcher.render([{
            isDarkTheme: true,
            elementId: 'productSwitcher',
            position: 'bottomLeft',
          }]);
        }

        // If Product switcher is populated, need to move the "More Links" a little towards left than the current position
        document.querySelector('#header .e-toolbar .e-toolbar-pop')?.setAttribute('style', 'right:85px;');
        document.querySelector('#header .e-toolbar .e-hor-nav')?.setAttribute('style', 'right:150px;');
      });

      // Append the script to the document's head
      this.renderer.appendChild(this.document.head, s);

    }
  }
}
